import React, { useState } from "react";
import styled from "@emotion/styled";
import { Tooltip } from "../../Tooltip";
import { getLocationPlans, Location } from "@ecologi/shared";
import QuestionIcon from "@ecologi/assets/icons/Plan/question_black.svg";
import { HowPlanCalculatedModal } from "./HowCalculatedPlanModal";

import styles from "../styles/Plan.module.scss";

type Props = {
  location: Location | null;
};

const Wrapper = styled.div`
  font-size: 14px;
  font-weight: lighter;
  text-align: center;
  padding: 0 24px;
  width: 100%;

  svg {
    margin-left: 4px;
  }

  @media ${({ theme }) => theme.bp.tabletUp} {
    padding: 0;
    text-align: left;
  }
`;

const Icon = styled(QuestionIcon)`
  flex-shrink: 0;
`;

export const FootprintMessage = ({ location }: Props) => {
  const [isHowCalculatedModalOpen, setIsHowCalculatedModalOpen] =
    useState(false);
  const { numTonnesPerPerson, locationConsumption, locationName } =
    getLocationPlans(location);

  return (
    <>
      <Wrapper>
        * Based on an average annual carbon footprint of {numTonnesPerPerson}{" "}
        tonnes CO<sub>2</sub>e per person
        <Tooltip content="How is this calculated?">
          <Icon
            aria-label="More details about calculation"
            className={styles.infoIcon}
            onClick={() => setIsHowCalculatedModalOpen(true)}
          />
        </Tooltip>
      </Wrapper>
      <HowPlanCalculatedModal
        isOpen={isHowCalculatedModalOpen}
        locationConsumption={locationConsumption}
        locationName={locationName}
        numTonnesPerPerson={numTonnesPerPerson}
        onClose={() => setIsHowCalculatedModalOpen(false)}
      />
    </>
  );
};
